"use strict";
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.throttle = void 0;

var _this = void 0;

var throttle = function throttle(callback) {
  var interval = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 200;
  var enableCall = true;
  return function () {
    if (!enableCall) return;
    enableCall = false;

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    callback.apply(_this, args);
    setTimeout(function () {
      enableCall = true;
    }, interval);
  };
};

exports.throttle = throttle;


//////////////////
// WEBPACK FOOTER
// ./js/utils/throttle.js
// module id = 783
// module chunks = 209 210 211 212